import { render, staticRenderFns } from "./blackMails.vue?vue&type=template&id=1e710c5e&scoped=true"
import script from "./blackMails.vue?vue&type=script&lang=js"
export * from "./blackMails.vue?vue&type=script&lang=js"
import style0 from "./blackMails.vue?vue&type=style&index=0&id=1e710c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e710c5e",
  null
  
)

export default component.exports